import axios from 'axios'
import qs from 'qs'
import company from './company'
import companyCore from './company-core'
import companyScope from './company-scope'
import sys from './sys'
import user from './user'
import doc from './doc'
import ticket from './ticket'
import auth from './auth'
import verify from "@/apis/verify";
import * as util from './util'

const fetch = axios.create({
  timeout: 10000,
  // baseURL: window.$bili_arcopen.isUAT ? '//uat-member.bilibili.com/' : '//member.bilibili.com'
})

fetch.interceptors.request.use(function (config) {
  if (!config.params) config.params = {}
  config.params = {
    ...config.params,
    n_ts: Date.now()
  }
  config.withCredentials = true
  if (!config.headers) config.headers = {}
  if (config.method !== 'get') {
    config.data = config.data || {}
    config.data.csrf = util.getCookie('bili_jct')
  }
  if (config.data && config.not_json) {
    config.data = qs.stringify(config.data)
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

fetch.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.message.indexOf('timeout') !== -1) {
    return Promise.reject(new Error('当前环境网络过慢，请求超时!'))
  }
  if (error.message.indexOf('Network') !== -1) {
    return Promise.reject(new Error('网络错误'))
  }
  return Promise.reject(error)
})

export default {
  user: user(fetch),
  company: company(fetch),
  companyCore: companyCore(fetch),
  companyScope: companyScope(fetch),
  sys: sys(fetch),
  doc: doc(fetch),
  verify: verify(fetch),
  ticket: ticket(fetch),
  auth: auth(fetch)
}
